<template>
  <div class="app flex-row align-items-center bg-login">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="4">
          <b-progress v-if="isLoading" :value="100" :max="100" animated></b-progress>
          <b-card-group class="box-shadow"> 
            
            <b-card no-body class="text pt-4 pb-0">
              <img src="/static/img/logo-iwk.png" style="margin: auto;" alt="">
              <b-card-body>
                <form class="app-login-box" method="POST" v-on:submit.prevent="onSubmit" autocomplete="">
                  <h3 style="text-align:center; margin-bottom:8px;">Forgot Password</h3>
                  <div v-if="errorMsg !== null" class="alert alert-danger">
                    <p v-html="errorMsg"></p>
                  </div>

                  <div class="input-group mb-3">
                    <span class="input-group-addon"><i class="icon-user"></i></span>
                    <input type="text" class="form-control" v-model="user.emailAddress.value" placeholder="Email" id="username" required>
                  </div>
                  <p v-if="user.emailAddress.error !== null" class="error">{{user.emailAddress.error}}</p>
    
                  <b-row>
                    <b-col md="12" lg="12">
                      <b-button type="submit" variant="primary" class="px-4 btn-block pull-right" style="border-radius: 3px;" :disabled="isLoading">
                        <!-- <i v-if="isLoading" class="fa fa-spinner fa-spin fa-fw"></i> -->
                        Reset Password
                        </b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12" lg="12" class="" style="text-align: right;">
                      <b-button to="/login" variant="link" class="text-muted px-0">back to log in</b-button>
                    </b-col>
                  </b-row>
                </form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'ForgotPassword',
  data () {
    return {
      errorMsg: null,
      successMsg: null,
      isLoading: false,
      user: {
        emailAddress: {
          rule: 'email',
          value: null,
          error: null
        }
      }
    }
  },
  methods: {
    onSubmit () {
      this.isLoading = true
      this.errorMsg = null
      let hasError = false
      for (let i = 0; i < Object.keys(this.user).length; i++) {
        if (this.user[Object.keys(this.user)[i]].value === null || this.user[Object.keys(this.user)[i]].value === '') {
          this.user[Object.keys(this.user)[i]].error = 'This field is required.'
          hasError = true
        } else if (this.user[Object.keys(this.user)[i]].rule === 'email' && /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.user[Object.keys(this.user)[i]].value) === false) { // eslint-disable-line
          this.user[Object.keys(this.user)[i]].error = 'This field must be email.'
          hasError = true
        } else {
          this.user[Object.keys(this.user)[i]].error = null
        }
      }
      if (hasError) {
        this.isLoading = false
        return false
      }
      axios.post(window.AppConfig.apiUrl + 'resetpassword/email', {
        emailAddress: this.user.emailAddress.value,
        account: window.AppConfig.subDomain
      })
        .then(response => {
          this.isLoading = false
          this.user.emailAddress.value = null
          this.successMsg = 'Password reset complete, Please check your email inbox or spam.'
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.errorMsg = errMsg
            })
        })
    }
  }
}
</script>
<style scoped>
  .bg-login {
    background: #3f82b6;
    /* background-image: linear-gradient(to right, #1D976C , #93F9B9); */
  }
  .bg-color {
    background-color: white;
    opacity: 0.9;
    filter: alpha(opacity=30);
  }
  .text {
    color:#536c79 !important;
  }
  .box-shadow {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
  .round-bg {
    margin: 0 auto;
    background: rgb(69, 190, 137);
    width: 30%;
    padding: 5px;
    margin-bottom: 8px;
    border-radius: 50px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
</style>


// WEBPACK FOOTER //
// src/views/auth/ForgotPassword.vue